import { InjectionKey } from 'vue';
import { FeatureFlagService } from '../service/feature-flags.service';

export const featureFlagServiceKey = Symbol() as InjectionKey<FeatureFlagService>;
